/*import Vue from 'vue'*/
import EventUtils from '@/utils/EventUtils.js';
import MapUtils from '@/utils/MapUtils.js';
import ConstUtils from '@/utils/ConstUtils.js'

const state = {
  list: [],
  map: {},
};

const getters = {
    CardStorage: state => state,
    CardStorage_size: state => state.list.length,
};

const actions = {
};

const mutations = {
  SOCKET_ONMESSAGE (state, event)  {
    if (event.status == EventUtils.STATUS.COMPLETE && event.statusCode == EventUtils.CODE.OK) {
      if (event.Payload && event.Payload.CardMap) {
        var items = event.Payload.CardMap;
        state.map = MapUtils.updateMap(items, state.map);
        state.list = Object.values(state.map);
      }
      if (event.Payload && event.Payload.Card) {
        var obj = event.Payload.Card;
        state.map[obj[ConstUtils.FIELDS.ID]] = obj;
        state.list = Object.values(state.map);
      }
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};